import { render, staticRenderFns } from "./list.vue?vue&type=template&id=240abdc0&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"
import style0 from "./list.vue?vue&type=style&index=0&id=240abdc0&prod&lang=scss&scoped=true"
import style1 from "./list.vue?vue&type=style&index=1&id=240abdc0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_b5e12a4b1c1729405afdf532a227c02e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240abdc0",
  null
  
)

export default component.exports